import { PackageSubLOBProps } from "components/flexComponents/WizardPackagePWA/typings";
import * as React from "react";
import { observer } from "mobx-react";
import { Location } from "src/components/shared/Location/Location";
import { Dates } from "src/components/shared/Dates/Dates";
import { PackagePartialStay } from "components/flexComponents/WizardPackagePWA/components/PackagePartialStay";
import { UitkLayoutConditionalGridSpan } from "uitk-react-layout-grid";
import { Viewport, ViewSmall, ViewMedium } from "@shared-ui/viewport-context";

export const FlightHotelCar = observer((props: PackageSubLOBProps) => {
  const locationColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 12, large: 8 };
  const datesColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 12, large: 4 };
  const datesPartialStayColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 6, large: 8 };
  const { isFlightHotelCarFormValid, updateInvalidFormsState } = props.packageWizardState;

  if (isFlightHotelCarFormValid) {
    updateInvalidFormsState();
  }

  return (
    <>
      <Location
        setInputsRefs={props.setInputsRefs}
        originField={true}
        destinationField={true}
        lobState={props.packageWizardState}
        colSpan={locationColSpan}
        showSwapLocationsControl={true}
        globalConfig={props.globalConfig}
      />
      <Dates lobState={props.packageWizardState} colSpan={datesColSpan} setInputsRefs={props.setInputsRefs} />

      <PackagePartialStay togglePartialStay={props.togglePartialStay} packageWizardState={props.packageWizardState} />
      {props.packageWizardState.partialStay && (
        <Viewport>
          <ViewSmall>
            <Dates
              lobState={props.packageWizardState}
              isPartialStay={true}
              colSpan={datesPartialStayColSpan}
              stackedDates={true}
              setInputsRefs={props.setInputsRefs}
            />
          </ViewSmall>
          <ViewMedium>
            <Dates
              lobState={props.packageWizardState}
              isPartialStay={true}
              colSpan={datesPartialStayColSpan}
              setInputsRefs={props.setInputsRefs}
            />
          </ViewMedium>
        </Viewport>
      )}
    </>
  );
});
